import React from 'react';

interface UnitErrorWarningProps {
  testName: string;
  currentUnit: string;
  suggestedUnit?: string;
  reason?: string;
  onFixUnit?: () => void;
}

export const UnitErrorWarning: React.FC<UnitErrorWarningProps> = ({
  testName,
  currentUnit,
  suggestedUnit,
  reason,
  onFixUnit
}) => {
  return (
    <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-red-600 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">
            Invalid Unit Detected
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{reason || `"${currentUnit}" is not a valid unit for ${testName}.`}</p>
            {suggestedUnit && (
              <p className="mt-1">
                Suggested unit: <span className="font-medium">{suggestedUnit}</span>
              </p>
            )}
            <p className="mt-2 text-xs">
              Due to the invalid unit, reference ranges cannot be displayed. 
              Please correct the unit in the Report Manager to see normal ranges.
            </p>
          </div>
          {onFixUnit && (
            <div className="mt-3">
              <button
                onClick={onFixUnit}
                className="text-sm bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition-colors"
              >
                Go to Report Manager
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};